// app entry
import '@@/core/polyfill'

import('./bootstrap');

// generated at 2024/8/29 16:51:58 by sui v3.0.51